/**
 * Il segno di GridFly (GI-277): una «G» il cui tratto orizzontale e' un
 * conduttore che cede — la campata — con il nodo dove si misura.
 *
 * Tre colori, presi dai gettoni: l'arco nell'accento del contorno, il filo
 * nell'inchiostro, il nodo nel magenta dei segni fatti a mano — lo stesso
 * del riquadro che l'operatore disegna sul fotogramma. Sulla barra dei
 * moduli, che e' scura in entrambi i contorni, valgono i colori fissi.
 */
export function Mark({
  size = 28,
  fixed = false,
  title,
}: {
  size?: number
  /** Colori della cabina qualunque sia il contorno: per la barra dei moduli. */
  fixed?: boolean
  /** Il nome per chi legge con lo schermo; senza, il segno e' decorativo. */
  title?: string
}): JSX.Element {
  const arc = fixed ? 'var(--brand-arc-dark)' : 'var(--brand-arc)'
  const wire = fixed ? 'var(--brand-wire-dark)' : 'var(--brand-wire)'
  return (
    <svg
      viewBox="0 0 64 64"
      width={size}
      height={size}
      role={title === undefined ? undefined : 'img'}
      aria-label={title}
      aria-hidden={title === undefined ? true : undefined}
      className="marchio"
    >
      <path d="M45.20 18.33A19 19 0 1 0 50.65 35.62" fill="none" stroke={arc} strokeWidth="6.5" strokeLinecap="round" />
      <path d="M50.65 35.62Q41 40.5 31 35.8" fill="none" stroke={wire} strokeWidth="6.5" strokeLinecap="round" />
      <circle cx="31" cy="35.8" r="4.9" fill="var(--brand-node)" />
    </svg>
  )
}
